import { isEn } from "project-config/utils/env";

export const enI18n = {
  common_cancel: "Cancel",
  common_confirm: "Confirm",
};
export const zhI18n = {
  common_cancel: "取消",
  common_confirm: "确定",
};

export const getTranslateNsT = (local: "zh" | "en" = isEn() ? "en" : "zh") => {
  return (key: string) =>
    ({
      zh: zhI18n,
      en: enI18n,
    }[local][key] || "");
};
